export default {
  baseUrl: 'https://api.createmyresume.work',
  v1: 'api/v1'
}